import { render, staticRenderFns } from "./EChartsTest.vue?vue&type=template&id=7afbca0b&scoped=true&"
import script from "./EChartsTest.vue?vue&type=script&lang=js&"
export * from "./EChartsTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afbca0b",
  null
  
)

export default component.exports